import { render, staticRenderFns } from "./ModalSendIrMacro.vue?vue&type=template&id=6440259a&scoped=true&"
import script from "./ModalSendIrMacro.vue?vue&type=script&lang=js&"
export * from "./ModalSendIrMacro.vue?vue&type=script&lang=js&"
import style0 from "./ModalSendIrMacro.vue?vue&type=style&index=0&id=6440259a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6440259a",
  null
  
)

export default component.exports